import Link from "next/link";

export function ShindanBanner() {
  return (
    <Link href="/shindan?from=top_banner">
      <a className="block">
        <div className="relative overflow-hidden rounded-xl bg-gradient-to-r from-[#0073BF] to-[#005A96] px-6 py-5 text-white shadow-md transition-transform hover:scale-[1.01] active:scale-[0.99] md:px-8 md:py-6">
          <div className="relative z-10">
            <p className="text-xs font-bold text-[#7ACBFF] md:text-sm">無料・2〜3分・スマホでOK</p>
            <h3 className="mt-1 text-lg font-extrabold leading-tight md:text-xl">
              あなたの会社、AI活用できていますか？
            </h3>
            <p className="mt-2 flex items-center gap-1 text-sm font-bold md:text-base">
              ▶ 無料で診断する
              <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
              </svg>
            </p>
          </div>
          <div className="absolute right-4 top-1/2 -translate-y-1/2 text-5xl opacity-20 md:right-8 md:text-7xl">
            📊
          </div>
        </div>
      </a>
    </Link>
  );
}
